<template>
  <div class="wrapper">

    <w-navbar icon="iconchevron-left"
              nav_title="当前状态"
              right_btn_html="确认"
              :cvShow="true"
              @mobileLeftBtn="goBackFunc"
              @mobileRightBtn="confirmFunc"/>

    <div class="input-box">
      <input class="input" v-model="value" maxlength="50" placeholder="如：在职" type="text">
      <div class="input-length-box">
        <span>{{ value.length }}</span>/50
      </div>
    </div>

    <div class="tag-box">
      <div class="tag-item" :class="{'active': item === value}" v-for="(item, index) in map" :key="`tagItem&${index}`" @click="selectTagFunc(item)">{{ item }}</div>
    </div>

  </div>
</template>

<script>
  import WNavbar from '@/components/global/w-navbar'
	import { mapState, mapMutations, mapActions } from 'vuex'

  export default {
    data () {
      return {
        value: '',
        map: [ '在职，正在找工作', '应届毕业生','离职，随时到岗', '在职，考虑机会', '在职，月内到岗', '正在找工作',  '随时到岗', '在校生', '应届生', '求职中', '实习中', '在职', '离职', '待业', '在读' ]
      }
    },
    components: {
      WNavbar
    },
    computed: {
			...mapState('cv', [ 'cvIntentionData' ])
    },
    created () {
      console.log('$route', this.$route)
      this.value = this.cvIntentionData.current_job || ''
    },
    methods: {
      ...mapMutations('cv', [ 'setCvIntentionData' ]),

      selectTagFunc (data) {
        this.value = data
      },
      goBackFunc () {
        this.$router.replace(`/cvs/${this.$route.params.token}/profiles`)
      },
      confirmFunc () {
        this.setCvIntentionData({
          ...this.cvIntentionData,
          current_job:  this.value
        })
        this.goBackFunc()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    padding: 44px 24px 0;

    .input-box {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      margin-top: 32px;
      border-bottom: 1px solid #EEEFF0;

      .input {
        flex: 1;
        height: 22px;
        border: none;
        color: #404040;
        padding: 0;

        &::placeholder {
          color: #bcbcbc;
        }

      }

      .input-length-box {
        width: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #CFCFCF;
        line-height: 22px;
        text-align: right;

        >span {
          color: #404040;
        }
      }
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;

      .tag-item {
        border-radius: 18px;
        border: 1px solid #ECECEC;
        padding: 8px 26px;
        font-size: 14px;
        color: #9C9C9C;
        line-height: 20px;
        margin-bottom: 10px;
        margin-right: 11px;

        &.active {
          color: #FF6644;
          border-color: #FF6644;
        }
      }
    }
  }
</style>
